import { gql, useQuery } from "@apollo/client";
import { MyAppSettingQueryQuery } from "../../../schemaTypes";

export const myAppSettingQuery = gql`
  query MyAppSettingQuery {
    myAppSetting {
      id
      isNotification
      isPush
      isEmail
      isSMS
      topUpLimit
      location{
        id
        city
      }
      createdAt
      updatedAt
    }
  }
`;

export interface WithMyAppSetting {
  data: MyAppSettingQueryQuery | null;
  loading: boolean;
}

interface Props {
  children: (data: WithMyAppSetting) => React.ReactElement | null;
}

export const MyAppSettingController: React.FC<Props> = ({ children }) => {
  const { data, loading } = useQuery<MyAppSettingQueryQuery>(myAppSettingQuery);

  // let match: User | null = null;
  let myAppSettingData: MyAppSettingQueryQuery | null = null;
  if (data) {
    myAppSettingData = data;
  }

  return children({
    data: myAppSettingData,
    loading
  });
};